/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Session } from '../entities';
// @ts-ignore
import type { SessionCreateRequest } from '../entities';
// @ts-ignore
import type { SessionPublishStatusTransitRequest } from '../entities';
// @ts-ignore
import type { SessionSearchRequest } from '../entities';
// @ts-ignore
import type { SessionSearchResponse } from '../entities';
// @ts-ignore
import type { SessionTitleUpdate } from '../entities';
// @ts-ignore
import type { SessionUpdatDateRequest } from '../entities';
// @ts-ignore
import type { SessionUpdateRequest } from '../entities';
// @ts-ignore
import type { SessionUpdateResponse } from '../entities';
// @ts-ignore
import type { WorkoutSessionsCreateRequest } from '../entities';
// @ts-ignore
import type { WorkoutSessionsCreateResponse } from '../entities';
/**
 * SessionControllerApi - axios parameter creator
 * @export
 */
export const SessionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SessionCreateRequest} sessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create5: async (sessionCreateRequest: SessionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionCreateRequest' is not null or undefined
            assertParamExists('create5', 'sessionCreateRequest', sessionCreateRequest)
            const localVarPath = `/session/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkoutSessionsCreateRequest} workoutSessionsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkoutSessions: async (workoutSessionsCreateRequest: WorkoutSessionsCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workoutSessionsCreateRequest' is not null or undefined
            assertParamExists('createWorkoutSessions', 'workoutSessionsCreateRequest', workoutSessionsCreateRequest)
            const localVarPath = `/session/createWorkoutSessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workoutSessionsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete4: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete4', 'id', id)
            const localVarPath = `/session/{id}/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SessionCreateRequest} sessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicate: async (sessionCreateRequest: SessionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionCreateRequest' is not null or undefined
            assertParamExists('duplicate', 'sessionCreateRequest', sessionCreateRequest)
            const localVarPath = `/session/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get2: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get2', 'id', id)
            const localVarPath = `/session/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch2: async (id: number, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patch2', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patch2', 'body', body)
            const localVarPath = `/session/{id}/patch`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SessionSearchRequest} sessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search4: async (sessionSearchRequest: SessionSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionSearchRequest' is not null or undefined
            assertParamExists('search4', 'sessionSearchRequest', sessionSearchRequest)
            const localVarPath = `/session/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SessionSearchRequest} sessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBasic: async (sessionSearchRequest: SessionSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionSearchRequest' is not null or undefined
            assertParamExists('searchBasic', 'sessionSearchRequest', sessionSearchRequest)
            const localVarPath = `/session/search/basic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionPublishStatusTransitRequest} sessionPublishStatusTransitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transit: async (id: number, sessionPublishStatusTransitRequest: SessionPublishStatusTransitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transit', 'id', id)
            // verify required parameter 'sessionPublishStatusTransitRequest' is not null or undefined
            assertParamExists('transit', 'sessionPublishStatusTransitRequest', sessionPublishStatusTransitRequest)
            const localVarPath = `/session/{id}/transit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionPublishStatusTransitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SessionUpdateRequest} sessionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1: async (sessionUpdateRequest: SessionUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUpdateRequest' is not null or undefined
            assertParamExists('update1', 'sessionUpdateRequest', sessionUpdateRequest)
            const localVarPath = `/session/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} archive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchive: async (id: number, archive: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateArchive', 'id', id)
            // verify required parameter 'archive' is not null or undefined
            assertParamExists('updateArchive', 'archive', archive)
            const localVarPath = `/session/{id}/update/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionUpdatDateRequest} sessionUpdatDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDate: async (id: number, sessionUpdatDateRequest: SessionUpdatDateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDate', 'id', id)
            // verify required parameter 'sessionUpdatDateRequest' is not null or undefined
            assertParamExists('updateDate', 'sessionUpdatDateRequest', sessionUpdatDateRequest)
            const localVarPath = `/session/{id}/update/date`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionUpdatDateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionTitleUpdate} sessionTitleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitle: async (id: number, sessionTitleUpdate: SessionTitleUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTitle', 'id', id)
            // verify required parameter 'sessionTitleUpdate' is not null or undefined
            assertParamExists('updateTitle', 'sessionTitleUpdate', sessionTitleUpdate)
            const localVarPath = `/session/{id}/update/title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionTitleUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails2: async (id: number, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserDetails2', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateUserDetails2', 'body', body)
            const localVarPath = `/session/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionControllerApi - functional programming interface
 * @export
 */
export const SessionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SessionCreateRequest} sessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create5(sessionCreateRequest: SessionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create5(sessionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.create5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WorkoutSessionsCreateRequest} workoutSessionsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkoutSessions(workoutSessionsCreateRequest: WorkoutSessionsCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkoutSessionsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkoutSessions(workoutSessionsCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.createWorkoutSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete4(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete4(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.delete4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SessionCreateRequest} sessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicate(sessionCreateRequest: SessionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicate(sessionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.duplicate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get2(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get2(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.get2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patch2(id: number, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patch2(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.patch2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SessionSearchRequest} sessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search4(sessionSearchRequest: SessionSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search4(sessionSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.search4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SessionSearchRequest} sessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBasic(sessionSearchRequest: SessionSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBasic(sessionSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.searchBasic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionPublishStatusTransitRequest} sessionPublishStatusTransitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transit(id: number, sessionPublishStatusTransitRequest: SessionPublishStatusTransitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transit(id, sessionPublishStatusTransitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.transit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SessionUpdateRequest} sessionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update1(sessionUpdateRequest: SessionUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update1(sessionUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.update1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} archive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArchive(id: number, archive: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArchive(id, archive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.updateArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionUpdatDateRequest} sessionUpdatDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDate(id: number, sessionUpdatDateRequest: SessionUpdatDateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDate(id, sessionUpdatDateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.updateDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionTitleUpdate} sessionTitleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTitle(id: number, sessionTitleUpdate: SessionTitleUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTitle(id, sessionTitleUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.updateTitle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDetails2(id: number, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: boolean; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDetails2(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionControllerApi.updateUserDetails2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SessionControllerApi - factory interface
 * @export
 */
export const SessionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {SessionCreateRequest} sessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create5(sessionCreateRequest: SessionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Session> {
            return localVarFp.create5(sessionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkoutSessionsCreateRequest} workoutSessionsCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkoutSessions(workoutSessionsCreateRequest: WorkoutSessionsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkoutSessionsCreateResponse> {
            return localVarFp.createWorkoutSessions(workoutSessionsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete4(id: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.delete4(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SessionCreateRequest} sessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicate(sessionCreateRequest: SessionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Session> {
            return localVarFp.duplicate(sessionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get2(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Session> {
            return localVarFp.get2(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch2(id: number, body: object, options?: RawAxiosRequestConfig): AxiosPromise<Session> {
            return localVarFp.patch2(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SessionSearchRequest} sessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search4(sessionSearchRequest: SessionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionSearchResponse> {
            return localVarFp.search4(sessionSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SessionSearchRequest} sessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBasic(sessionSearchRequest: SessionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionSearchResponse> {
            return localVarFp.searchBasic(sessionSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionPublishStatusTransitRequest} sessionPublishStatusTransitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transit(id: number, sessionPublishStatusTransitRequest: SessionPublishStatusTransitRequest, options?: RawAxiosRequestConfig): AxiosPromise<Session> {
            return localVarFp.transit(id, sessionPublishStatusTransitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SessionUpdateRequest} sessionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1(sessionUpdateRequest: SessionUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionUpdateResponse> {
            return localVarFp.update1(sessionUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} archive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchive(id: number, archive: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Session> {
            return localVarFp.updateArchive(id, archive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionUpdatDateRequest} sessionUpdatDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDate(id: number, sessionUpdatDateRequest: SessionUpdatDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Session> {
            return localVarFp.updateDate(id, sessionUpdatDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {SessionTitleUpdate} sessionTitleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitle(id: number, sessionTitleUpdate: SessionTitleUpdate, options?: RawAxiosRequestConfig): AxiosPromise<Session> {
            return localVarFp.updateTitle(id, sessionTitleUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails2(id: number, body: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: boolean; }>> {
            return localVarFp.updateUserDetails2(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionControllerApi - object-oriented interface
 * @export
 * @class SessionControllerApi
 * @extends {BaseAPI}
 */
export class SessionControllerApi extends BaseAPI {
    /**
     * 
     * @param {SessionCreateRequest} sessionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public create5(sessionCreateRequest: SessionCreateRequest, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).create5(sessionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkoutSessionsCreateRequest} workoutSessionsCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public createWorkoutSessions(workoutSessionsCreateRequest: WorkoutSessionsCreateRequest, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).createWorkoutSessions(workoutSessionsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public delete4(id: number, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).delete4(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SessionCreateRequest} sessionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public duplicate(sessionCreateRequest: SessionCreateRequest, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).duplicate(sessionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public get2(id: number, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).get2(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public patch2(id: number, body: object, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).patch2(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SessionSearchRequest} sessionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public search4(sessionSearchRequest: SessionSearchRequest, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).search4(sessionSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SessionSearchRequest} sessionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public searchBasic(sessionSearchRequest: SessionSearchRequest, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).searchBasic(sessionSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {SessionPublishStatusTransitRequest} sessionPublishStatusTransitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public transit(id: number, sessionPublishStatusTransitRequest: SessionPublishStatusTransitRequest, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).transit(id, sessionPublishStatusTransitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SessionUpdateRequest} sessionUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public update1(sessionUpdateRequest: SessionUpdateRequest, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).update1(sessionUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} archive 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public updateArchive(id: number, archive: boolean, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).updateArchive(id, archive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {SessionUpdatDateRequest} sessionUpdatDateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public updateDate(id: number, sessionUpdatDateRequest: SessionUpdatDateRequest, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).updateDate(id, sessionUpdatDateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {SessionTitleUpdate} sessionTitleUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public updateTitle(id: number, sessionTitleUpdate: SessionTitleUpdate, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).updateTitle(id, sessionTitleUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionControllerApi
     */
    public updateUserDetails2(id: number, body: string, options?: RawAxiosRequestConfig) {
        return SessionControllerApiFp(this.configuration).updateUserDetails2(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}

